import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { processLoginGG } from "services/user/userService";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CheckCode = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const orderID = localStorage.getItem("orderID");

  // Lấy các tham số từ URL
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const error = queryParams.get("error");
  const status = queryParams.get("status");

  useEffect(() => {
    if (code && location.search.includes("google")) {
      const fetchUserInfo = async () => {
        try {
          const response = await processLoginGG(code);
          if (response.status === 200) {
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("name", response.data.data.fullName);
            localStorage.setItem("role", response.data.data.role);
            localStorage.setItem(
              "itemQuantityInCart",
              response.data.data.itemQuantityInCart
            );
            navigate("/");
          }
        } catch (err) {
          if (err.response && err.response.status === 403) {
            Swal.fire({
              icon: "error",
              text: "Tài khoản đã bị khóa. Vui lòng liên hệ hỗ trợ.",
              timer: 5000,
              timerProgressBar: true,
              showConfirmButton: false,
              customClass: {
                popup: "my-swal",
              },
            }).then(() => {
              navigate("/login");
            });
          }
        }
      };

      fetchUserInfo();
    }
  }, [code, location.search, navigate]); // useEffect chạy lại khi `code` hoặc `location.search` thay đổi

  useEffect(() => {
    // Nếu `status` là PAID, chuyển hướng đến trang thành công
    if (status === "PAID") {
      navigate(`order-success/${orderID}`);
    }
  }, [status, orderID, navigate]); // useEffect chạy lại khi `status` hoặc `orderID` thay đổi

  return null;
};

export default CheckCode;
